import React from "react";
import { motion, AnimatePresence } from "framer-motion";

function Slidersection({
  open,
  onClose,
  width = "20rem",
  children,
  activeIndex,
}) {
  const variants = {
    desktop: {
      initial: { x: "100%" },
      animate: { x: 0 },
      exit: { x: "100%" },
    },
    mobile: {
      initial: { y: "100%" },
      animate: { y: 0 },
      exit: { y: "100%" },
    },
  };

  const isMobile = window.matchMedia("(max-width: 640px)").matches;
  const activeVariant = isMobile ? variants.desktop : variants.desktop;
  return (
    <div className="relative flex h-full overflow-x-clip">
      <AnimatePresence>
        {open && (
          <motion.div
            key="slide-panel"
            initial={activeVariant.initial}
            animate={activeVariant.animate}
            exit={activeVariant.exit}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
            className={`shadow-md border-2 bg-white 
              ${
                isMobile
                  ? "absolute bottom-0 w-full rounded-t-xl"
                  : "absolute right-0 bottom-0 rounded-xl"
              }`}
            style={!isMobile ? { width } : {}}
          >
            {/* Close button just above the panel content */}
            <span className="border-b px-6 py-4 w-full flex justify-between items-center">
              <span className="text-lg font-semibold">
                {" "}
                {activeIndex === 0 && "About Job"}
                {activeIndex === 1 && "Take notes"}
                {activeIndex === 2 && "Video Curator"}
              </span>
              <button
                onClick={onClose}
                className="  text-gray-500 font-semibold hover:text-amber-500 text-lg text-right  transition-all duration-200 ease-in-out "
              >
                ✕
              </button>
            </span>

            {/* Panel content at the bottom */}
            <div className="p-4">{children.panel}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Slidersection;
